import { z } from 'zod';
export const basePainAssessmentSchema = z.object({
    hasPain: z.string().optional(),
    primarySite: z.string().optional(),
    receivedBy: z.string().optional(),
    interferesWithActivity: z.string().optional(),
    currentPainIntensity: z.string().optional(),
    pastPainBest: z.string().optional(),
    pastPainWorst: z.string().optional(),
    description: z.array(z.string()).optional(),
    nonverbalPainCues: z.array(z.string()).optional(),
    relievedBy: z.array(z.string()).optional(),
    relievedByOther: z.string().optional(),
    managementEffectiveness: z.string().optional(),
    aberrantBehavior: z.array(z.string()).optional(),
    painFrequency: z.string().optional(),
    comments: z.string().optional(),
    nonverbalSymptoms: z.array(z.string()).optional(),
    adlImpact: z.string().optional(),
    reliefMeasures: z.string().optional(),
});
